import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";

//import images
import logo from "../../assets/images/logo-dark.png";
import logoHorizontal from "../../assets/images/logo-horizontal.png";
import { createSelector } from "reselect";
import { LayoutState } from "slices/layouts/reducer";
import { useSelector } from "react-redux";

const selectLayout = createSelector(
  (state: any) => state.Layout,
  ({ isMenuOpen }: LayoutState) => ({
    isMenuOpen
  })
)


const Sidebar = (props: any) => {

  const { isMenuOpen } = useSelector(selectLayout)
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={isMenuOpen ? logoHorizontal : logo} alt="" height="40" />
            </span>
            <span className="logo-lg">
              <img src={isMenuOpen ? logoHorizontal : logo} alt="" height="60" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={isMenuOpen ? logoHorizontal : logo} alt="" height="40" />
            </span>
            <span className="logo-lg">
              <img src={isMenuOpen ? logoHorizontal : logo} alt="" height="60" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;